// This file defines common procedure code sets with their CPT codes
export interface ProcedureCodeSet {
  name: string;
  cptCodes: string[];
}

export const procedureCodeSets: ProcedureCodeSet[] = [
  {
    name: "Ankle tendon repair with bunionectomy",
    cptCodes: ["27691", "28300", "28298"]
  },
  {
    name: "Arthroplasty wrist",
    cptCodes: ["25447", "26483"]
  },
  {
    name: "Barricade",
    cptCodes: ["C9757"]
  },
  {
    name: "Breast reconstruction with implants",
    cptCodes: ["19380", "19380", "11970", "11970", "19350", "19350"]
  },
  {
    name: "Bunionectomy with hammertoe",
    cptCodes: ["28296", "28285", "28270"]
  },
  {
    name: "Cervical fusion/ACDF multi level",
    cptCodes: ["22551", "22552", "22845", "22853", "22853", "20930", "20936"]
  },
  {
    name: "Cervical fusion/ACDF single level",
    cptCodes: ["22551", "22845", "22853", "20930", "20936"]
  },
  {
    name: "Cochlear implantation",
    cptCodes: ["69930", "69667", "15770"]
  },
  {
    name: "Complex ear - with mastoidectomy",
    cptCodes: ["69643", "69310", "21235", "15770"]
  },
  {
    name: "Complex ear - without mastoidectomy",
    cptCodes: ["69631", "21235", "15770"]
  },
  {
    name: "Disc replacement- cervical - multi level",
    cptCodes: ["22856", "22858"]
  },
  {
    name: "Ear tube placement (bilateral)",
    cptCodes: ["69436", "69436"]
  },
  {
    name: "Elbow scope - multi procedure",
    cptCodes: ["29838", "29836", "29834"]
  },
  {
    name: "ESI - Cervical",
    cptCodes: ["62321"]
  },
  {
    name: "ESI - Lumbar",
    cptCodes: ["62323"]
  },
  {
    name: "Excision bone cyst, finger",
    cptCodes: ["26210", "14040"]
  },
  {
    name: "Excision skull cust with repair",
    cptCodes: ["62120", "15770"]
  },
  {
    name: "Facet injections - cervical",
    cptCodes: ["64490", "64491", "64492"]
  },
  {
    name: "Facet injections - lumbar",
    cptCodes: ["64493", "64494", "64495"]
  },
  {
    name: "Hip replacement - total",
    cptCodes: ["27130", "20985", "64450"]
  },
  {
    name: "Hip scope",
    cptCodes: ["29914", "29916"]
  },
  {
    name: "Inspire procedure",
    cptCodes: ["64582"]
  },
  {
    name: "Joint injection with trigger point injections",
    cptCodes: ["20610", "20550"]
  },
  {
    name: "Knee replacement - partial",
    cptCodes: ["27446", "64447", "20985"]
  },
  {
    name: "Knee replacement - total",
    cptCodes: ["27447", "64447", "20985"]
  },
  {
    name: "Knee scope - ACL repair",
    cptCodes: ["29888"]
  },
  {
    name: "Knee scope - menisectomy",
    cptCodes: ["29881"]
  },
  {
    name: "Knee scope - multi procedure",
    cptCodes: ["29881", "29879", "29876"]
  },
  {
    name: "Kyphoplasty, multi level",
    cptCodes: ["22514", "22515"]
  },
  {
    name: "Lap Chole",
    cptCodes: ["47563", "47379"]
  },
  {
    name: "Lumbar discectomy",
    cptCodes: ["63030", "63035"]
  },
  {
    name: "Lumbar fusion multi level",
    cptCodes: ["22630", "22632", "22853", "22853", "22840", "63052", "20930", "20936"]
  },
  {
    name: "Lumbar fusion single level",
    cptCodes: ["22630", "22840", "22853", "63052", "20930", "20936"]
  },
  {
    name: "Lumbar laminectomy",
    cptCodes: ["63047", "63048"]
  },
  {
    name: "Minuteman procedure",
    cptCodes: ["22899"]
  },
  {
    name: "Pain pump insertion",
    cptCodes: ["62362", "62350"]
  },
  {
    name: "Palm and finger fasciotomy",
    cptCodes: ["26123", "26125"]
  },
  {
    name: "Permanent stimulator",
    cptCodes: ["63685", "63650", "63650"]
  },
  {
    name: "Rhizotomy cervical bilateral",
    cptCodes: ["64633", "64633", "64634", "64634"]
  },
  {
    name: "Rhizotomy lumbar bilateral",
    cptCodes: ["64635", "64635", "64636", "64636"]
  },
  {
    name: "Shoulder replacement - total",
    cptCodes: ["23472", "64415"]
  },
  {
    name: "Shoulder scope - debridement",
    cptCodes: ["29823"]
  },
  {
    name: "Shoulder scope - multi procedure",
    cptCodes: ["29827", "29828", "29823"]
  },
  {
    name: "Shoulder scope - RTC repair",
    cptCodes: ["29827", "29828", "29826"]
  },
  {
    name: "Shoulder scope - SLAP repair",
    cptCodes: ["29807", "29806", "29824"]
  },
  {
    name: "SI Joint fusion",
    cptCodes: ["27279"]
  },
  {
    name: "SI joint injection",
    cptCodes: ["27096", "G0260"]
  },
  {
    name: "Sinus surgery - multi procedure",
    cptCodes: ["30520", "31267", "31267", "31255", "31255", "30140", "30140", "31276", "31276", "31288", "31288"]
  },
  {
    name: "Transforaminal injection lumbar bilateral",
    cptCodes: ["64483", "64483", "64484", "64484"]
  },
  {
    name: "Trial stimulator/leads",
    cptCodes: ["63650", "63650"]
  },
  {
    name: "Trigger finger release, multi finger",
    cptCodes: ["26055", "26055"]
  },
  {
    name: "Tubes and Adenoids",
    cptCodes: ["42830", "69436", "69436"]
  },
  {
    name: "Ulnar nerve release",
    cptCodes: ["64718", "64719"]
  },
  {
    name: "Wrist scope with CTR",
    cptCodes: ["29848", "26145"]
  },
  {
    name: "Wrist scope with debridement",
    cptCodes: ["29846", "25118"]
  }
];
